import { render, staticRenderFns } from "./historicalTask.vue?vue&type=template&id=744e9064&scoped=true&"
import script from "./historicalTask.vue?vue&type=script&lang=js&"
export * from "./historicalTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e9064",
  null
  
)

export default component.exports